import ApplicationProcess from "../components/pages/ApplicationProcess";

export default ApplicationProcess;
